import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { ScreenCopy, ScreenCreate, ScreenEdit } from 'constants/routerPath';

const DEFAULT_SCROLL_TO_TOP_PATHS = [ScreenCreate, ScreenEdit, ScreenCopy];

const DEFAULT_SCROLL_TO_TOP_CONFIG: Record<string, boolean> = {
    [ScreenCreate]: true,
    [ScreenEdit]: true,
    [ScreenCopy]: true,
};

export function useScrollToTopConfig() {
    const location = useLocation();

    const isEnabled = useMemo(() => {
        const pathname = location.pathname;

        if (DEFAULT_SCROLL_TO_TOP_CONFIG[pathname]) {
            return true;
        }

        return DEFAULT_SCROLL_TO_TOP_PATHS.some((path) => pathname.startsWith(path));
    }, [location.pathname]);

    return { isEnabled };
}
